<!--
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2022-01-04 19:39:00
 * @LastEditors: voanit
 * @LastEditTime: 2022-01-05 21:15:05
-->
<template>
  <span class="svg-container" v-if="iconName">
    <svg class="icon" aria-hidden="true">
      <use :xlink:href="iconName"></use>
    </svg>
  </span>
</template>

<script>
export default {
  name: 'iconSvg',
  props: {
    iconClass: {
      type: String,
      required: true,
    },
  },
  computed: {
    iconName() {
      return this.iconClass ?  `#${this.iconClass}` : ''
    },
  },
}
</script>
<style lang="scss" scoped>
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  // font-size: 16px;
}
</style>
